module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/does-it-look-difficult-or-should-i-just-say-no.json
// module id = 1339
// module chunks = 63825502211210